export class PerformanceTimer {
  private _started: number | null = null;
  private _ended: number | null = null;

  public get started() {
    return this._started;
  }

  public get ended() {
    return this._ended;
  }

  public start() {
    this._ended = null;
    this._started = performance.now();
  }

  public stop() {
    this._ended = performance.now();
  }

  public reset() {
    this._started = null;
    this._ended = null;
  }

  public get duration() {
    return (this._ended ?? performance.now()) - (this._started ?? performance.now());
  }

  public get durationInSeconds() {
    return this.duration / 1000;
  }

  public toString(fractionDigits: number = 0) {
    return this.duration.toFixed(fractionDigits);
  }

  public toSecondsString(fractionDigits: number = 0) {
    return this.durationInSeconds.toFixed(fractionDigits);
  }
}
